import $ from 'jquery';

import setBrnhcdSelectBoxOptions from '../setBrnhcdSelectBoxOptions';

const setupDlrcdSelectBoxOnChange = () => {
	$('#api-DLRCD').on('change', (event) => {
		setBrnhcdSelectBoxOptions(event.target.value);
	});
};

export default setupDlrcdSelectBoxOnChange;



// WEBPACK FOOTER //
// ./src/js/index/onChange/setupDlrcdSelectBoxOnChange.js